import { useEffect, useRef, useState } from 'react';
import { useElena } from '../state';

/** Shows the oldest pending approval request. Elena waits until you answer or time runs out. */
export function ConfirmDialog() {
  const { confirms, answer } = useElena();
  const current = confirms[0];
  const [left, setLeft] = useState(0);
  const approveRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!current) return;
    approveRef.current?.focus();
    const tick = () => {
      const s = Math.max(
        0,
        Math.round((new Date(current.expiresAt).getTime() - Date.now()) / 1000),
      );
      setLeft(s);
      if (s === 0) answer(current.confirmId, false);
    };
    tick();
    const t = window.setInterval(tick, 1000);
    return () => window.clearInterval(t);
  }, [current, answer]);

  if (!current) return null;

  return (
    <div className="overlay" role="presentation">
      <div
        className="dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        aria-describedby="confirm-desc"
      >
        <p className="muted small">Elena traži potvrdu · još {left} s</p>
        <h2 id="confirm-title" className="dialog-title">
          {current.summary}?
        </h2>
        <p id="confirm-desc" className="muted">
          Ovo je akcija za koju si rekao da Elena prvo pita.
        </p>
        <div className="row gap-8">
          <button
            ref={approveRef}
            type="button"
            className="btn primary grow"
            onClick={() => answer(current.confirmId, true)}
          >
            Dozvoli
          </button>
          <button
            type="button"
            className="btn grow"
            onClick={() => answer(current.confirmId, false)}
          >
            Odbij
          </button>
        </div>
      </div>
    </div>
  );
}
